export default __webpack_public_path__ + "static/media/logo.011f51ec.svg";